import { Alert } from "@mui/material";
import React, { ReactElement } from "react";

const Disclaimer = (): ReactElement => {
  return (
    <Alert severity="warning" sx={{ marginBottom: 2 }}>
      These models and results are for testing only. Outputs may be inaccurate, and no responsibility is accepted for decisions or actions based on them.
    </Alert>
  );
};

export default Disclaimer;
